<template v-once>
  <img src="@/assets/icons/medscape_icon.png" alt="medscape icon">
</template>

<script>
export default {
  name: "Medscape",
};
</script>

<style scoped>
</style>